var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMostrar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-outline",
    clipPath: "url(#clip0_379_272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.984 5.24634C8.33089 5.24634 4.58351 7.36071 1.63342 11.5895C1.54922 11.7115 1.50307 11.8557 1.50082 12.004C1.49857 12.1522 1.54031 12.2978 1.62077 12.4224C3.88747 15.9705 7.58469 18.7453 11.984 18.7453C16.3356 18.7453 20.1087 15.9621 22.3797 12.406C22.4582 12.2839 22.5 12.1417 22.5 11.9965C22.5 11.8513 22.4582 11.7092 22.3797 11.5871C20.1036 8.07175 16.3028 5.24634 11.984 5.24634Z",
    stroke: "#474747",
    strokeWidth: 1.49989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 15.7456C14.0706 15.7456 15.7494 14.0668 15.7494 11.9959C15.7494 9.92496 14.0706 8.24615 11.9997 8.24615C9.92881 8.24615 8.25 9.92496 8.25 11.9959C8.25 14.0668 9.92881 15.7456 11.9997 15.7456Z",
    stroke: "#474747",
    strokeWidth: 1.49989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9982,
    height: 23.9982,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostrar);
export default __webpack_public_path__ + "static/media/Mostrar.7f029a568205d8cf9e8eba89a12384d5.svg";
export { ForwardRef as ReactComponent };